import { CircularProgress, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { useTheme } from '@mui/material/styles'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import { TextBold } from '../../../commonComponents/TextStyling'
import NoRecordFound from '../../../commonComponents/NoRecordFound'
import { logoutUser } from '../../../actions/loginActions'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import serverData from '../../../api/ServerData'
import AppButton from '../../../commonComponents/AppButton'
import AddUsersModal from './AddUsersModal'
import { showToast } from '../../../utils/AppHelper'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.opposite,
    fontSize: 16,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    fontWeight: 600
  }
}))

export default function ManageUsers () {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  const [subEmployers, setSubEmployers] = useState([])
  const [openModal, setOpenModal] = useState({ open: false })

  useEffect(function () {
    getSubEmployers()
  }, [])

  function getSubEmployers () {
    serverData.getSubEmployers(
      {},
      result => {
        if (result.status) {
          setSubEmployers(result.response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container>
      <Grid container style={{display:'flex',justifyContent:'space-between',}}>
      <Grid item xs={6}>
        <TextBold style={{ fontSize: '24px' }}>Manage Users</TextBold>
      </Grid>
      <Grid
        item
        xs={4}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          
        }}
      >
        <AppButton
        style={{fontSize:'13px'}}  
          fullWidth={false}
          onClick={() => {
            setOpenModal({
              open: true,
              onReload: getSubEmployers,
              onClose: () => {
                setOpenModal({
                  open: false
                })
              }
            })
          }}
          name={'Add new user'}
        />
        </Grid>
      </Grid>
      {loading ? (
        <Grid
          container
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <UsersContent data={subEmployers} />
      )}
      {openModal?.open && <AddUsersModal data={openModal} />}
    </Grid>
  )
}

function UsersContent ({ data }) {
  const theme = useTheme()
  return data.length > 0 ? (
    <TableContainer
      component={Paper}
      style={{ borderRadius: '16px', marginTop: 16 }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell>Number of jobs</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell>Comments</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(row => (
            <TableRow
              key={row.applicationId}
              sx={{
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              }}
            >
              <StyledTableCell>
                {row.firstname} {row.lastname}
              </StyledTableCell>
              <StyledTableCell
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {row.email}
                {row.isEmailVerified === 0 && <ResendEmail item={row} />}
              </StyledTableCell>
              <StyledTableCell>{row.numberOfJobs}</StyledTableCell>
              <StyledTableCell>{row.status}</StyledTableCell>
              <StyledTableCell>{row.comments}</StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoRecordFound />
  )
}

function ResendEmail ({ item }) {
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  function resendSubEmployerEmail () {
    setLoading(true)
    serverData.resendSubEmployerEmail(
      { id: item.id },
      result => {
        if (result.status) {
          showToast(result.message, false)
        } else {
          showToast(result.message)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <AppButton
      name={'Resend'}
      loading={loading}
      variant='text'
      fullWidth={false}
      style={{ marginLeft: 8 }}
      onClick={() => {
        resendSubEmployerEmail()
      }}
    />
  )
}
